var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitzerlandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 207,
    viewBox: "0 0 207 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Untitled design 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11439_445",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 203,
    height: 203
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "53154675a3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.29999 2.3H204.7V204.7H2.29999V2.3Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11439_445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11439_445",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 203,
    height: 203
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "6296133e1e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.40179 103.5L103.5 2.40082L204.598 103.5L103.5 204.598L2.40179 103.5Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11439_445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.40179 103.5L103.5 2.40082L204.598 103.5L103.5 204.598L2.40179 103.5Z",
    fill: "#B1DBE1"
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.1347 96.612C60.6545 96.612 62.0082 94.6684 62.0082 90.4477C62.0082 86.0194 60.5747 84.3623 57.3413 84.3623C56.5127 84.3623 55.9238 84.506 55.5574 84.6817L55.4935 96.612H57.1347ZM70.2758 109.068C70.2758 109.068 68.985 109.467 67.1053 109.467C66.2298 109.467 64.5248 109.387 63.0753 108.192C61.4352 106.854 60.2402 104.13 56.6884 97.5993H55.4935V103.732C55.4935 107.794 55.6373 108.558 57.3093 108.845V109.387C56.5127 109.355 54.4104 109.307 53.0567 109.307C51.7031 109.307 49.5998 109.339 48.8041 109.387V108.845C50.4762 108.558 50.62 107.794 50.62 103.732V88.52C50.62 84.4581 50.4762 83.6934 48.8041 83.4069V82.8659C49.5998 82.8968 51.7031 82.9447 53.0887 82.9447C55.0473 82.9447 56.6405 82.8659 57.6597 82.8659C64.0796 82.8659 67.2491 85.8118 67.2491 90.1292C67.2491 93.2508 65.4811 95.7195 61.4831 97.0891C62.9006 101.04 67.9978 108.24 70.2758 108.781V109.068Z",
    fill: "#174B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.7175 92.0399C87.7175 84.6179 87.1115 83.964 85.0251 83.391V82.8499C85.8218 82.8809 87.0327 82.9288 88.3703 82.9288C89.5972 82.9288 90.4567 82.8968 91.2054 82.8499V83.391C89.2628 83.964 89.2308 84.6498 89.2308 92.0719V99.2714C89.2308 105.006 87.5737 109.467 81.075 109.467C77.1568 109.467 74.3527 108.606 72.6327 106.408C71.3749 104.783 70.8328 102.776 70.8328 99.3033V88.4562C70.8328 84.4262 70.6901 83.6615 69.033 83.375V82.834C69.8296 82.8659 71.9 82.9128 73.2386 82.9128C74.5603 82.9128 76.6467 82.8809 77.4433 82.834V83.375C75.7872 83.6615 75.6435 84.4262 75.6435 88.4562V99.1606C75.6435 105.787 76.5669 107.778 81.2188 108.096C85.9655 108.096 87.7175 105.213 87.7175 98.6984V92.0399Z",
    fill: "#174B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M111.467 92.0399C111.467 84.6179 110.861 83.964 108.775 83.391V82.8499C109.571 82.8809 110.781 82.9288 112.12 82.9288C113.346 82.9288 114.206 82.8968 114.955 82.8499V83.391C113.011 83.964 112.98 84.6498 112.98 92.0719V99.2714C112.98 105.006 111.323 109.467 104.825 109.467C100.907 109.467 98.1024 108.606 96.3824 106.408C95.1236 104.783 94.5825 102.776 94.5825 99.3033V88.4562C94.5825 84.4262 94.4388 83.6615 92.7827 83.375V82.834C93.5793 82.8659 95.6497 82.9128 96.9873 82.9128C98.31 82.9128 100.396 82.8809 101.193 82.834V83.375C99.5359 83.6615 99.3932 84.4262 99.3932 88.4562V99.1606C99.3932 105.787 100.317 107.762 104.967 108.096C109.714 108.096 111.467 105.213 111.467 98.6984V92.0399Z",
    fill: "#174B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M123.413 95.5768V107.698C124.018 107.953 125.038 108.016 125.818 108.016C128.335 108.016 130.709 106.456 130.709 101.661C130.709 97.3447 128.574 95.5768 124.592 95.5768H123.413ZM124.496 94.4138C127.523 94.4138 128.813 92.8206 128.813 88.5839C128.813 85.2547 127.316 83.949 125.006 83.949C124.528 83.949 123.954 84.0598 123.413 84.2674V94.4138H124.496ZM117.169 108.813C118.731 108.526 118.873 107.762 118.873 103.7V88.5041C118.873 84.4421 118.731 83.6775 117.169 83.391V82.8499C117.918 82.8809 119.878 82.9288 121.135 82.9288C124.321 82.9288 125.786 82.8499 127.65 82.8499C131.824 82.8499 133.719 85.4294 133.719 88.5839C133.719 91.451 132.19 93.8079 128.653 94.7482C133.066 95.3691 135.614 97.6152 135.614 101.677C135.614 105.229 134.022 109.403 127.157 109.403C125.628 109.403 123.732 109.291 121.119 109.291C119.862 109.291 117.902 109.323 117.153 109.371V108.813H117.169Z",
    fill: "#174B4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M150.428 109.355C149.632 109.323 147.529 109.275 146.191 109.275C144.853 109.275 142.751 109.307 141.954 109.355V108.813C143.626 108.526 143.77 107.762 143.77 103.7V100.546L137.207 87.7075C135.646 84.6658 134.881 83.4229 134.022 83.391V82.8499C134.787 82.8809 137.207 82.9288 138.561 82.9288C140.122 82.9288 142.257 82.8968 143.053 82.8499V83.391C141.922 83.6136 141.381 83.933 141.381 84.7606C141.381 85.4145 141.668 86.2899 142.4 87.8033L147.402 98.3959L151.75 89.1569C152.403 87.7873 152.977 86.3219 152.977 85.3186C152.977 84.4102 152.579 83.6455 151.304 83.391V82.8499C152.1 82.8809 153.662 82.9288 154.999 82.9288C156.226 82.9288 157.102 82.8968 157.866 82.8499V83.391C155.844 84.0758 154.825 86.226 153.041 89.9536L148.613 99.1925V103.684C148.613 107.746 148.755 108.51 150.428 108.797V109.355Z",
    fill: "#174B4B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M59.6743 125.233C59.9379 125.408 60.2014 125.555 60.465 125.672C60.7285 125.79 60.9741 125.886 61.2037 125.963C61.4353 126.041 61.6439 126.095 61.8306 126.127C62.0193 126.159 62.172 126.175 62.2898 126.175C62.4575 126.175 62.5663 126.149 62.6172 126.095C62.6701 126.039 62.6971 125.978 62.6971 125.911C62.6971 125.832 62.6741 125.774 62.6292 125.736C62.5863 125.699 62.5274 125.674 62.4535 125.66C62.3577 125.639 62.2219 125.612 62.0462 125.58C61.8705 125.546 61.6749 125.495 61.4592 125.428C61.2436 125.362 61.021 125.272 60.7924 125.161C60.5658 125.047 60.3502 124.901 60.1455 124.725C59.9319 124.534 59.7622 124.306 59.6344 124.043C59.5066 123.779 59.4427 123.454 59.4427 123.064C59.4427 122.671 59.5166 122.309 59.6664 121.978C59.8181 121.649 60.0317 121.365 60.3092 121.128C60.5888 120.888 60.9282 120.704 61.3275 120.577C61.7268 120.449 62.179 120.385 62.6851 120.385C62.9267 120.385 63.1763 120.4 63.4318 120.429C63.6894 120.459 63.9429 120.501 64.1905 120.557C64.4401 120.611 64.6786 120.675 64.9052 120.752C65.1309 120.83 65.3365 120.915 65.5202 121.008V123.615C65.2646 123.483 65.0131 123.372 64.7655 123.284C64.5199 123.196 64.2913 123.126 64.0787 123.072C63.8681 123.016 63.6804 122.976 63.5157 122.953C63.35 122.927 63.2162 122.913 63.1124 122.913C62.9526 122.913 62.8448 122.939 62.7889 122.988C62.733 123.039 62.7051 123.094 62.7051 123.152C62.7051 123.235 62.73 123.296 62.7809 123.336C62.8339 123.376 62.8937 123.407 62.9606 123.428C63.0405 123.45 63.1643 123.479 63.332 123.516C63.5017 123.553 63.6894 123.601 63.895 123.659C64.0997 123.718 64.3143 123.797 64.5379 123.895C64.7615 123.994 64.9711 124.12 65.1688 124.274C65.7039 124.713 65.9714 125.286 65.9714 125.991C65.9714 126.373 65.8955 126.722 65.7438 127.041C65.5941 127.359 65.3774 127.631 65.0929 127.86C64.8074 128.087 64.459 128.263 64.0467 128.391C63.6365 128.519 63.1723 128.583 62.6532 128.583C62.147 128.583 61.623 128.527 61.0799 128.415C60.5368 128.301 60.0677 128.142 59.6743 127.936V125.233Z",
    fill: "#174B4B"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M66.2877 120.505H69.7816L70.5722 124.198H70.5962L71.267 120.505H73.4752L74.134 124.198H74.158L74.9606 120.505H78.1271L75.7831 128.463H72.8922L72.2094 125.364H72.1894L71.5186 128.463H68.6156L66.2877 120.505Z",
    fill: "#174B4B"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M78.7099 120.505H81.9882V128.463H78.7099V120.505Z",
    fill: "#174B4B"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M85.0625 123.208H82.8424V120.505H90.557V123.208H88.3369V128.463H85.0625V123.208Z",
    fill: "#174B4B"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M93.8287 123.188L93.8167 123.164H91.4089V120.505H98.6962L98.7082 120.525L95.8412 125.911L95.8492 125.935H98.5126V128.463H91.0376L91.0256 128.439L93.8287 123.188Z",
    fill: "#174B4B"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M99.3513 120.505H105.077V123.164H102.63V123.591H104.606V125.484H102.63V125.935H105.233V128.463H99.3513V120.505Z",
    fill: "#174B4B"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M106.041 120.505H109.308C109.717 120.505 110.148 120.539 110.601 120.605C111.057 120.669 111.474 120.792 111.855 120.976C112.239 121.16 112.554 121.417 112.802 121.747C113.051 122.077 113.177 122.505 113.177 123.032C113.177 123.464 113.085 123.834 112.901 124.142C112.718 124.452 112.475 124.712 112.175 124.925L113.992 128.463H110.55L109.364 125.847H109.32V128.463H106.041V120.505ZM109.559 124.023C109.815 124.023 110.002 123.963 110.122 123.843C110.244 123.721 110.306 123.575 110.306 123.408C110.306 123.238 110.244 123.094 110.122 122.976C110.002 122.86 109.815 122.801 109.559 122.801H109.32V124.023H109.559Z",
    fill: "#174B4B"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M114.324 120.505H117.603V125.636H120.062V128.463H114.324V120.505Z",
    fill: "#174B4B"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M123.531 120.505H126.665L129.7 128.463H126.158L125.883 127.417H124.058L123.751 128.463H120.5L123.531 120.505ZM125.356 125.416L125.004 123.803H124.984L124.633 125.416H125.356Z",
    fill: "#174B4B"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M130.242 120.505H133.221L135.565 123.903L135.585 123.891V120.505H138.532V128.463H135.553L133.209 125.065L133.189 125.077V128.463H130.242V120.505Z",
    fill: "#174B4B"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M139.492 128.463V120.505H142.822C143.598 120.505 144.28 120.616 144.866 120.836C145.454 121.055 145.949 121.358 146.352 121.747C146.703 122.085 146.983 122.481 147.19 122.937C147.4 123.39 147.506 123.905 147.506 124.482C147.506 125.033 147.406 125.54 147.206 126.003C147.009 126.464 146.732 126.866 146.376 127.209C145.957 127.606 145.453 127.915 144.862 128.136C144.271 128.354 143.598 128.463 142.846 128.463H139.492ZM142.77 125.867H142.846C143.122 125.867 143.363 125.828 143.569 125.748C143.776 125.668 143.945 125.558 144.076 125.416C144.184 125.299 144.272 125.163 144.339 125.005C144.405 124.848 144.439 124.674 144.439 124.482C144.439 124.285 144.405 124.107 144.339 123.947C144.272 123.785 144.184 123.645 144.076 123.528C143.958 123.403 143.804 123.3 143.612 123.22C143.423 123.14 143.174 123.1 142.866 123.1H142.77V125.867Z",
    fill: "#174B4B"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerlandLogo);
export default __webpack_public_path__ + "static/media/switzerland-logo.42f2f8261493bb07e90d0959ffa25660.svg";
export { ForwardRef as ReactComponent };